/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_phred_field_p = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error probability (P)`)
};

const es_phred_field_p = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Probabilidad de error (P)`)
};

const de_phred_field_p = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehlerwahrscheinlichkeit (P)`)
};

const nl_phred_field_p = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foutkans (P)`)
};

const fr_phred_field_p = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Probabilité d'erreur (P)`)
};

const it_phred_field_p = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Probabilità di errore (P)`)
};

const pt_br2_phred_field_p = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Probabilidade de erro (P)`)
};

const pt_phred_field_p = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Probabilidade de erro (P)`)
};

const ja_phred_field_p = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エラー確率 (P)`)
};

const zh_phred_field_p = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`错误概率（P）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const phred_field_p = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.phred_field_p(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("phred_field_p", locale)
	if (locale === "en") return en_phred_field_p(inputs)
	if (locale === "es") return es_phred_field_p(inputs)
	if (locale === "de") return de_phred_field_p(inputs)
	if (locale === "nl") return nl_phred_field_p(inputs)
	if (locale === "fr") return fr_phred_field_p(inputs)
	if (locale === "it") return it_phred_field_p(inputs)
	if (locale === "pt-BR") return pt_br2_phred_field_p(inputs)
	if (locale === "pt") return pt_phred_field_p(inputs)
	if (locale === "ja") return ja_phred_field_p(inputs)
	return zh_phred_field_p(inputs)
};